module.exports = __webpack_public_path__ + "media/components/theme/fonts/CooperHewitt-Bold-d5fb7c6fc3ef4fb20d63c9816db8ffb0.eot";